import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

const StartRpaProcess = (data: any) =>
  request({
    url: ApiURL.Query.startRpaProcess,
    method: RequestType.POST,
    data: data,
  });
  const StartListOfRpaProcess = (data: any) =>
  request({
    url: ApiURL.Query.startListOfRpaProcess,
    method: RequestType.POST,
    data: data,
  });

  const RpaRequestList = (data: any) => {
    let url = `${ApiURL.Query.rpaRequestList}?take=${data.take}&skip=${data.skip}`;
    if (data.searchKeyword) {
        url += `&searchKeyword=${data.searchKeyword}`;
    }
    return request({
      url: url,
      method: RequestType.GET,
      data: data,
    });
  };

  const RpaActionList = (data: { take: number; skip: number; rpaRequestId: number }) =>
    request({
      url: `${ApiURL.Query.rpaActionList}?take=${data.take}&skip=${data.skip}&rpaRequestId=${data.rpaRequestId}`,
      method: RequestType.GET,
    });

const RpaQuery = {
  StartRpaProcess,
  StartListOfRpaProcess,
  RpaRequestList,
  RpaActionList,
};
export default RpaQuery;
